import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.footerContent}>
                    {/* Company Info */}
                    <div className={styles.companyInfo}>
                        <h3 className={styles.footerLogo}>
                            <span className={styles.hyphen}>-</span>
                            Apexbit
                            <span className={styles.hyphen}>-</span>
                        </h3>
                        <p className={styles.footerDescription}>
                            Providing exceptional digital solutions with quality and care. 
                            Transforming businesses through innovative technology.
                        </p>
                    </div>

                    {/* Navigation Links - Horizontal on large screens */}
                    <div className={styles.footerNavigation}>
                        <div className={styles.footerLinks}>
                            <div className={styles.linkGroup}>
                                <h4>Navigation</h4>
                                <ul className={styles.linkList}>
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/services">Services</Link></li>
                                <li><Link to="/about">About</Link></li>
                                <li><Link to="/contact">Contact</Link></li>
                                </ul>
                            </div>

                            <div className={styles.linkGroup}>
                                <h4>Services</h4>
                                <ul className={styles.linkList}>
                                <li><Link to="/services">Web Development</Link></li>
                                <li><Link to="/services">UI/UX Design</Link></li>
                                <li><Link to="/services">Mobile Apps</Link></li>
                                <li><Link to="/services">SEO Optimisation</Link></li>
                                </ul>
                            </div>

                            <div className={styles.linkGroup}>
                                <h4>Legal</h4>
                                <ul className={styles.linkList}>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className={styles.footerBottom}>
                    <div className={styles.footerBottomContent}>
                        <p className={styles.copyright}>
                            &copy; {currentYear} Apexbit. All rights reserved.
                        </p>
                        <div className={styles.legalLinks}>
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <span className={styles.separator}>|</span>
                            <Link to="/terms-conditions">Terms & Conditions</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;